import { ReadonlyRecord } from '@bimser/core';
import { List, Record } from 'immutable';
import { ISearchItem, SearchItem, SearchItemFactoryFromJS } from './ISearchItem';

interface IBaseDataSearchState {
	activeChildPanelGuid: string;
	loading: boolean;
}

export interface IDataSearchState extends IBaseDataSearchState {
	searchItems: ISearchItem[];
}

export interface IReadonlyDataSearchState extends IBaseDataSearchState {
	searchItems: List<SearchItem>;
}

export type DataSearchState = ReadonlyRecord<IReadonlyDataSearchState>;

export const DataSearchStateFactory = Record<IReadonlyDataSearchState>({
	searchItems: List(),
	activeChildPanelGuid: null,
	loading: false
});

export const DataSearchStateFactoryFromJS = function (data: IDataSearchState) {
	return DataSearchStateFactory({
		...data,
		searchItems: List(data.searchItems.map(searchItem => SearchItemFactoryFromJS(searchItem)))
	});
};
